import { defineStore } from 'pinia';
import type { IModalState } from '../types/store-states.types';


export const useModalStore = defineStore('au-modal', {
  state: () => ({
    modals: [],
  } as IModalState),

  getters: {
    getModals: (state) => state.modals,
  },

  actions: {
    register(name: string, key: string) {
      this.filterModalList(name, key);
      this.modals.push({
        name: name,
        key: key,
        isOpen: false,
        options: {} as any,
      });
    },

    filterModalList(name: string, key: string) {
      const currentModalIndex = this.modals.findIndex(
        (modal) => modal.name === name && modal.key !== key
      );
      if (currentModalIndex != -1) {
        this.modals.splice(currentModalIndex, 1);
      }
    },

    getModalIdByKey(key: string): number {
      return this.modals.findIndex((modal) => modal.key === key);
    },

    getModalsByName(name: string) {
      return this.modals
        .filter((modal) => modal.name === name)
        .map((takenModal) => this.modals.find((modal) => modal.key === takenModal.key));
    },

    getModalIdsByName(name: string): number[] {
      return this.modals
        .filter((modal) => modal.name === name)
        .map((takenModal) => this.modals.findIndex((modal) => modal.key === takenModal.key));
    },

    updateOptions(key: string, options: any): void {
      const modalId = this.getModalIdByKey(key)
      this.modals[modalId].options = options;
    },

    toggle(key: string, isOpen: boolean): void {
      const modalId = this.getModalIdByKey(key)
      this.modals[modalId].isOpen = isOpen;
    },

    show(identity: string | number): void {
      switch(typeof identity) {
        case 'number':
          this.modals[identity].isOpen = true;
          break;
        case 'string':
          const modalId = this.getModalIdByKey(identity);
          this.modals[modalId].isOpen = true;
          break;
      }
    },

    hide(key: string): void {
      const modalId = this.getModalIdByKey(key)
      this.modals[modalId].isOpen = false;
    },
  },
});